const REACT_APP_API_BASE_URL = window._env_?.REACT_APP_API_BASE_URL || "https://moonstone.givadiva.co/api";
// const REACT_APP_API_BASE_URL = window._env_?.REACT_APP_API_BASE_URL || "http://127.0.0.1:5000/api";

export { REACT_APP_API_BASE_URL };
